<template>
  <div class="container">
    <audio ref="audioPlayer" controls class="reviewRadio">
      您的浏览器暂不支持播放该音频，请升级至最新版浏览器。
    </audio>
  </div>
</template>

<script>
let Hls = require('hls.js')

export default {
  props: ['audioSrc'],
  data () {
    return {
      // audioSrc: 'https://rim-multimedia-uat.pyamc.com/data/cham/multimedia/20220415/322bea86-2951-49cb-a4be-f4d7d32913ad.mp4/index.m3u8'
    }
  },
  mounted () {
    this.getStream()
  },
  methods: {
    getStream () {
      if (Hls.isSupported()) {
        this.hls = new Hls()
        this.hls.loadSource(this.audioSrc)
        console.log('文件地址：：：', this.audioSrc)
        this.hls.attachMedia(this.$refs.audioPlayer)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          console.log('加载成功', this.audioSrc)
          // this.$refs.audioPlayer.play()
        })
        this.hls.on(Hls.Events.ERROR, (event, data) => {
          console.log('加载失败', this.audioSrc)
        })
      } else if (
        this.$refs.audioPlayer.canPlayType('application/vnd.apple.mpegurl')
      ) {
        this.$refs.audioPlayer.src = this.audioSrc
        this.$refs.audioPlayer.addEventListener('loadedmetadata', function () {
          // this.$refs.audioPlayer.play()
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
}
.reviewRadio {
  width: 100%;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/StreamMediaAudio.vue